
class AuthUtils {
    static setTokenInLocalStorage(token, primary = true ){
        if(!token || token === "invalid" || token === "null" || token === "undefined"){
            console.trace("[TOKEN-REMOVE] setTokenInLocalStorage with empty/invalid token=" + token + " primary=" + primary)
        }
        let target = "accessToken"
        if( !primary ){
            target = "meterianXAuthToken"
            token = window.btoa("Bearer "+token)
        }
        window.localStorage.setItem(target, token)
    }

    static getTokenFromLocalStorage(primary = true, encoded = true){
        let target = "accessToken"
        if( !primary ){
            target = "meterianXAuthToken"
        }
        let accessToken = window.localStorage.getItem(target)
        if(!accessToken || (accessToken && accessToken.startsWith("null"))) return null
        if( !primary && !encoded ) {
            accessToken = window.atob(accessToken)
        }
        if( window.localStorage.clientFp && ( primary || !encoded) ) accessToken = accessToken+"+mfa:"+window.localStorage.clientFp
        if(accessToken && accessToken.startsWith("Bearer ")) accessToken = accessToken.split(" ")[1]  
        return accessToken
    }

    static getValidSsoError() {
        const raw = window.localStorage.getItem("ssoLoginError");
        if (!raw) return null;

        try {
            const { code, ts } = JSON.parse(raw);
            if (Date.now() - ts <= 30000) { // 30s TTL
                return code;
            }
        } catch (e) {
            console.error("Malformed SSO error data", e);
        }

        window.localStorage.removeItem("ssoLoginError");
        return null;
    }

    static removeAccessToken(tag){
        console.trace("[TOKEN-REMOVE] removeAccessToken tag=" + tag
            + " | accessToken=" + (window.localStorage.getItem("accessToken") || "<none>")
            + " | meterianXAuthToken=" + (window.localStorage.getItem("meterianXAuthToken") ? "<set>" : "<none>"))
        delete window.localStorage.removeItem("accessToken")
        delete window.localStorage.removeItem("meterianXAuthToken")
    }
}

if(window && !window.AuthUtils) window.AuthUtils = AuthUtils
class Headers{
    constructor(type, updateTimeout){
        let auth
        try{
            auth = process.env.METERIAN_API_TOKEN 
        }
        catch(e){
            auth = null
        }
        if(!types.isValid(type)) throw new Error("Auth type is not valid")
        if(type == types.types.TOKEN && (!auth || !auth.length)) throw new Error("Auth type is token but no token is specified")
        this.updateTimeout = updateTimeout || 1 * 1000
        this.auth = auth
        this.type = type
        // A static token comes from the environment, not from local storage, so it
        // must never be refreshed against AuthUtils - which does not exist off-web.
        this.usesStaticToken = !!auth
        this.updateAuth(auth, type)
        this.keepAuthUpdated(!!auth, auth, type)


    }
    generate(contentType=null, meterianXAuth=false){
        const headers = {}
        // Read the token now instead of trusting what the constructor cached. A page
        // that builds the SDK the instant a login resolves would otherwise send its
        // first requests with no Authorization header at all, and the gateway answers
        // those with a 404 - which reads as a missing endpoint, not as a failed login.
        if (!this.usesStaticToken) this.updateAuth(null, this.type)
        if (this.auth){
            headers["Authorization"] = this.auth
        }
        if (contentType){
            headers["Content-Type"] = contentType
        }
        if (meterianXAuth){
            const meterianXAuthTokenRaw = AuthUtils.getTokenFromLocalStorage(false)
            if(!meterianXAuthTokenRaw) throw new Error("Meterian XAuth token not found")
            headers["x-meterian-xauth"] = meterianXAuthTokenRaw
        }
        return headers
    }

    async keepAuthUpdated(usingToken, auth, type){
        let hasGlobal = false
        try{ 
            if(!global) throw new Error()
            hasGlobal = true
        }
        catch(e){}
        if(usingToken || (hasGlobal && global.expect && !global.forceUpdate)) return;
        await new Promise(resolve=>setTimeout(resolve,this.updateTimeout));
        this.updateAuth(null, type)
        this.keepAuthUpdated(usingToken, auth, type)
    }
    updateAuth(token, type){
        if(!token || !token.length) {
            token = AuthUtils.getTokenFromLocalStorage()
        }
        if(!token) return
        this.auth = type+" "+token
    }
}
class AuthTypesClass {
    constructor(){
        this.types = {
            BEARER: "Bearer",
            TOKEN: "token"
        }
    }
    isValid(type){
        for(const key in this.types){
            
            if(this.types[key] == type) return true
        }
        return false
    }
}


const types = new AuthTypesClass()
const AuthTypes = types.types


// License: PROPRIETARY
class Features {
	constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
		const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
		this.list = {}
	}
	async all (){
		try{
			const features = await fetch(`${this.baseUrl}/api/v1/admin/ag/features`,{
				headers: this.headers.generate()
			})
			const list = await features.json();
			for(const feature of list){
				this.list[feature]=false;
			}
		}
		catch(e){
			console.log(e);
			throw e
		}
	}

	init(profile) {

		try{
			if (profile.account) profile = profile.account;
			
			for (const feature in this.list) {
				this.list[feature] = false;
			}
			for (const feature of profile.features) {
				this.list[feature] = true;
			}
			
			if (profile.plan != "opensource" && !this.list.teams) {
				this.list.members = true
			}
			else{
				this.list.members = false;
			}
		}
		catch(e){
			console.log(e)
		}
	}


	async update(account, features) {
		if (!account || !account.uuid) throw { message: "No account has been specified", path: "MeterianSDK.Accounts.Features.update" }
		try {
			features = features.reduce((all, feature) => {
				if (feature == "members") return all;
				all.push(feature);
				return all;
			}, [])
			features = features.join(",");
			await fetch(`${this.baseUrl}/api/v1/accounts/${account.uuid}/features?names=${features}`, {
				method: "POST",
				headers: this.headers.generate()
			})
		}
		catch (e) {
			console.log(e);
			throw e
		}
	}

	get(){
		return this.list
	}

}


// License: PROPRIETARY
class Plans{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async all(){
        try{
            const plans = await fetch(`${this.baseUrl}/api/v1/admin/ag/plans`,{
                headers: this.headers.generate("application/json")
            })
            this.list= await plans.json();
            this.list.sort((a,b)=>{
                if(a.name < b.name) return -1;
                if(a.name > b.name) return 1;
                return 0;
            })
        }
        catch(e){
            console.log(e);
            throw e
        }
    }
    
    map(plans){
        const plansMap = {};
        for(const plan of plans){
            plansMap[plan.name]=plan;
        }
        return plansMap
    }
    async change(account,plan){
        if(!account || !account.uuid) throw {message: "No account has been specified", path: "MeterianSDK.Accounts.Plans.change" } 
        try{
            const r = await fetch(`${this.baseUrl}/api/v1/accounts/${account.uuid}/plan?name=${plan}`,{
                method: "POST",
                headers: this.headers.generate("application/json")
            })
            if(r.status!=200) throw await r.json()
        }
        catch(e){
            console.log(e);
            throw e;
        }
    }
    async getIllustration(plan){
        try{
            const request = await fetch(`/plans/${plan}-plan-illustration.json?slug=${Date.now()}`)
            return await request.json()
        }   
        catch(e){
            console.log(e)
        }
    }
}



// License: PROPRIETARY
class Properties {
    constructor(type, headers, baseUrl = ""){
        this.baseUrl = baseUrl
        if(type!="accounts" && type!="teams") throw new Error("Property type not allowed");
        this.type=type;

        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async all(){
        try{
            const type=this.type.slice(0,this.type.length-1);
            const properties = await fetch(`${this.baseUrl}/api/v1/admin/ag/${type}-properties`,{
                headers: this.headers.generate()
            })
            if(properties.status!=200) throw properties;
            this.list = await properties.json();
        }
        catch(e){
            console.log(e);
            throw await e.json();
        }
    }

   
    async get(name,subject){
        const uuid = subject.uuid;
        if(!uuid || !uuid.length) throw {message: "Cannot detect "+this.type+" uuid", path: "MeterianSDK."+this.type+".Properties.get"}
        try{
            const request = await  fetch(`${this.baseUrl}/api/v1/${this.type}/${uuid}/properties/${name}?s=${Date.now()}`,{
                headers: this.headers.generate()
            })
            if(request.status!=200) throw request;
            return await request.json();
        }
        catch(e){
            console.log(e);
            if(e.status==404) return null
            throw await e;
        }
    }

    async set(name,subject,property){
        const uuid = subject.uuid;
        if(property=="null" || property==null || property===undefined || property=="") property="null";

        else if(typeof property == "string" && property.length){
            try{
                JSON.parse(property)
            }
            catch(e){
                throw {message: "The property content is invalid", path: "MeterianSDK"+this.type+".Properties.set"}
            }
        }
        else if(typeof property != "object" || Array.isArray(property)){

            throw {message: "The property is invalid", path: "MeterianSDK."+this.type+".Properties.set"}
        }
        else {
            property=JSON.stringify(property)
        }
        
        if(!uuid || !uuid.length) throw {message: "Cannot detect "+this.type+" uuid", path: "MeterianSDK."+this.type+".Properties.set"}
        try{
            const res = await fetch(`${this.baseUrl}/api/v1/${this.type}/${uuid}/properties/${name}`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: property
            })
            if(res.status!=200) throw res;
        }
        catch(e){
            console.log(e);
            throw await e.json();
        }
    }

}



// License: PROPRIETARY
class Members{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)

        this.errors={
            notCreated:{message:"Oops... Something went wrong. The account member could not be created."},
            notDeleted:{message:"Oops... Something went wrong. The account member could not be deleted."},
            notUpdated:{message:"Oops... Something went wrong. The account member could not be updated."},
            notUpdatedTeam:{message:"Oops... Something went wrong. The team member could not be updated."},
            notUpdatedPrimary: {message:"Oops... Something went wrong! The primary team could not be changed."},
            missingParams:{message:"Some parameters necessary for the request are missing."}
        }
    }
    async all(accountUUID){

        if(!accountUUID || !accountUUID.length){
            const error = this.errors.missingParams;
            error.path="MeterianSDK.accounts.members.all"
            throw error
        } 
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/members`,{
                headers: this.headers.generate()
            })
            if(response.status!=200) throw await response.json();
            return await response.json()
        }
        catch(e){
            console.log(e);
            return []
        } 
        
    }

    async byEmail(accountUUID,memberEmail){
        if(!accountUUID || !accountUUID.length ||
            !memberEmail || !memberEmail.length ){
            const error = this.errors.missingParams;
            error.path = "MeterianSDK.accounts.members.byEmail";
            throw error
        } 
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/members/${memberEmail}`,{
                headers:this.headers.generate()
            })
            if(response.status!=200) throw await response.json();
            return await response.json()
        }
        catch(e){
            console.log(e)
            return null
        }
    };

    async create(accountUUID,memberInfo,shouldConsiderRole=false){
        if(!accountUUID || !accountUUID.length ||
            !memberInfo || !memberInfo.length){
            const error=this.errors.missingParams;
            error.path = "MeterianSDK.accounts.members.create";
            throw error
        }
           
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/members`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify({
                    name: memberInfo.name,
                    email: memberInfo.email,
                    role: shouldConsiderRole?memberInfo.role:"Viewer"
                })
            })
            if(response.status!=200) throw await response.json();
            return
        }
        catch(e){
            console.log(e);
            throw e
        }
    }
    
    async delete(accountUUID,memberEmail){
        if(!accountUUID || !accountUUID.length ||
            !memberEmail || !memberEmail.length) {
            const error = this.errors.missingParams;
            error.path="MeterianSDK.accounts.members.delete"
            throw error
        }
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/members/${memberEmail}`,{
                method:"DELETE",
                headers: this.headers.generate()
            })
            if(response.status!=200) throw await response.json();
            return
        }   
        catch(e){
            console.log(e);
            throw e
        }
    }

    async update(accountUUID,memberEmail,memberInfo){

        if(!accountUUID || accountUUID.length ||
            !memberEmail || !memberEmail.length ||
            !memberInfo) {
         
            const error= this.errors.missingParams;
            error.path="MeterianSDK.accounts.members.update"
            throw error
            
        }
        try{

            const response = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/members/${memberEmail}`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(memberInfo)
            })
            if(response.status!=200) throw await response.json()
            return
        }
        catch(e){
            console.log(e)
            throw e
        }

    }
    
    async setPrimaryTeam(accountUUID,memberEmail,teamUUID){
        if(!accountUUID || !accountUUID.length ||
            !memberEmail || !memberEmail.length || 
            !teamUUID || !teamUUID.length){
                
                const error =  this.errors.missingParams;
                error.path="MeterianSDK.accounts.members.setPrimaryTeam"
            } 
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/members/${memberEmail}/primary?teamuuid=${teamUUID}`,{
                method: "POST",
                headers: this.headers.generate()
            })
            if(response.status!=200) throw await response.json();
            return
        }
        catch(e){
            console.log(e);
            throw e
        }
    }

    uuid(accountUUID,teams,memberEmail){
        const membersList=teams.reduce(function(list,currentTeam){
            if(currentTeam.uuid==accountUUID) list=currentTeam.members;
            return list
        }.bind(this),[])
        return membersList.reduce(function(memberFound,currentMember){
            if(currentMember.email==memberEmail) memberFound=currentMember.uuid;
            return memberFound;
        },null)
    }
    
}




// License: PROPRIETARY

const POLICIES_PER_PAGE = 500
const SUCCESS_STATUSES = [200, 202]

const STATUS_MESSAGES = {
    400: "The request was rejected as invalid",
    401: "You are not allowed to perform this action on this scope",
    404: "That policy could not be found",
    409: "A policy already exists for this library in this scope"
}

class LibraryPolicies {
    constructor(headers, baseUrl = "") {
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers(isWeb ? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    endpointUrl(scopeUuid, policyUuid) {
        const collection = `${this.baseUrl}/api/v1/teams/${scopeUuid}/policies/dependencies`
        return policyUuid ? `${collection}/${policyUuid}` : collection
    }

    // DELETE answers 200 with no body, and an error can arrive with none
    // either, so a bare .json() would reject and lose the status.
    async readBody(response) {
        try { return await response.json() }
        catch (parseFailure) { return null }
    }

    failureFor(status, body) {
        const serverMessage = (body && body.message) || null
        const message = serverMessage || STATUS_MESSAGES[status] || "The request failed"
        // serverMessage distinguishes "the server explained this" from "we
        // filled in a generic string", so callers can prefer their own
        // context-specific wording over our fallback.
        return { ...(body || {}), status, serverMessage, message }
    }

    async readResponse(response) {
        const body = await this.readBody(response)
        if (SUCCESS_STATUSES.includes(response.status)) return body
        throw this.failureFor(response.status, body)
    }

    async fetchPage(scopeUuid, offset) {
        const response = await fetch(`${this.endpointUrl(scopeUuid)}?limit=${POLICIES_PER_PAGE}&offset=${offset}`, {
            headers: this.headers.generate()
        })
        const body = await this.readResponse(response)
        const policies = (body && body.policies) || []
        const total = typeof (body && body.total) === "number" ? body.total : policies.length
        return { policies, total }
    }

    async all(scopeUuid) {
        const firstPage = await this.fetchPage(scopeUuid, 0)
        const policies = [...firstPage.policies]
        const pageCount = Math.max(1, Math.ceil(firstPage.total / POLICIES_PER_PAGE))

        for (let pageIndex = 1; pageIndex < pageCount && policies.length < firstPage.total; pageIndex++) {
            const page = await this.fetchPage(scopeUuid, pageIndex * POLICIES_PER_PAGE)
            if (!page.policies.length) break
            policies.push(...page.policies)
        }
        return policies
    }

    async get(scopeUuid, policyUuid) {
        const response = await fetch(this.endpointUrl(scopeUuid, policyUuid), { headers: this.headers.generate() })
        return await this.readResponse(response)
    }

    async create(scopeUuid, policy) {
        const response = await fetch(this.endpointUrl(scopeUuid), {
            method: "POST",
            headers: this.headers.generate("application/json"),
            // The scope travels in both the path and the body - the server
            // uses this body copy of teamUuid to establish the policy's scope.
            body: JSON.stringify({
                library: policy.library,
                versionRange: policy.versionRange,
                severity: policy.severity,
                description: policy.description,
                teamUuid: scopeUuid
            })
        })
        return await this.readResponse(response)
    }

    async update(scopeUuid, policyUuid, policy) {
        // active is mandatory server-side; a primitive default here would
        // silently deactivate the policy under the editing user's name.
        if (!policy || typeof policy.active !== "boolean") {
            throw this.failureFor(400, { message: "The active state must be supplied when updating a policy" })
        }
        const response = await fetch(this.endpointUrl(scopeUuid, policyUuid), {
            method: "POST",
            headers: this.headers.generate("application/json"),
            body: JSON.stringify({
                versionRange: policy.versionRange,
                severity: policy.severity,
                description: policy.description || "",
                active: policy.active
            })
        })
        return await this.readResponse(response)
    }

    async remove(scopeUuid, policyUuid) {
        const response = await fetch(this.endpointUrl(scopeUuid, policyUuid), {
            method: "DELETE",
            headers: this.headers.generate()
        })
        await this.readResponse(response)
        return null
    }

    // The endpoint answers 202 Accepted with a job, not results - readResponse
    // already treats 202 as success.
    async startAutoProvision(scopeUuid) {
        const response = await fetch(`${this.endpointUrl(scopeUuid)}/autoprovision`, {
            method: "POST",
            headers: this.headers.generate("application/json")
        })
        return await this.readResponse(response)
    }

    // A 404 here means this server instance has no job for the scope - jobs are
    // held in memory. The caller distinguishes that from a failure by status.
    async autoProvisionStatus(scopeUuid) {
        const response = await fetch(`${this.endpointUrl(scopeUuid)}/autoprovision/status`, {
            headers: this.headers.generate()
        })
        return await this.readResponse(response)
    }
}


// License: PROPRIETARY
class TeamMembers{
    constructor(errors, headers, baseUrl = ""){
        this.baseUrl = baseUrl
        this.errors=errors;
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async add(teamUUID,memberInfo,accountMember){
        if(!memberInfo && (!teamUUID || !accountMember)){
            const error=this.errors.missingParams;
            error.path="MeterianSDK.Teams.TeamMembers.add"
            throw error
        }
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/teams/${teamUUID}/members`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify({
                    uuid: accountMember, 
                    role: memberInfo.role,
                    membership: accountMember?null:{
                        name: memberInfo.name,
                        email: memberInfo.email,
                        role: "Viewer"
                    }
                })
            })
            if(response.status!=200) throw await response.json();
            return;
        }
        catch(e){
            console.log(e);
            throw e;
        }
    }

    async update(teamUUID,memberUUID,memberInfo){
        if(!teamUUID || !memberUUID || !memberInfo) {
            const error = this.errors.missingParams;
            error.path = "MeterianSDK.Teams.TeamMembers.add";
            throw error
        }
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/teams/${teamUUID}/members/${memberUUID}`,{
                method: "POST",
                headers:  this.headers.generate("application/json"),
                body: JSON.stringify(memberInfo)
            })
            if(response.status!=200) throw await response.json();
            return
        }
        catch(e){
            console.log(e);
            throw e
        }
    }

    async remove(teamUUID,memberUUID){
        if(!teamUUID || !memberUUID) {
            const error=this.errors.missingParams;
            error.path="MeterianSDK.Teams.TeamMembers.remove"
            throw error
        }
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/teams/${teamUUID}/members/${memberUUID}`,{
                method: "DELETE",
                headers: this.headers.generate()
            })
            if(!response.status!=200) throw await response.json();
            return
        }
        catch(e){
            console.log(e);
            throw e
        }
    }
    async all(teamUUID){
        if(!teamUUID){
            const error=this.errors.missingParams;
            error.path="MeterianSDK.Teams.TeamMembers.all"
            throw error
        } 
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/teams/${teamUUID}/members`,{
                headers: this.headers.generate()
            })
            if(response.status!=200) throw await response.json()
            return await response.json();
        }
        catch(e){
            console.log(e);
            return []
        }
    }

    

    doesTeamMemberExist(teams,teamUUID,memberUUID){
        const membersList=teams.reduce(function(list,currentTeam){
            if(currentTeam.uuid==teamUUID) list=currentTeam.members;
            return list
        },[])
        return membersList.reduce(function(memberFound,currentMember){
            if(currentMember.uuid==memberUUID) memberFound=true;
            return memberFound;
        },false)
    }


}



class Teams{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        const errors={
            missingParams:{message:"Some parameters necessary for the request are missing"},
            notAdded:{message:"Oops... Something went wrong. The member has not been added to the team"},
            notCreated:{message:"Oops... Something went wrong. The team could not be created."},
            notDeleted:{message:"Oops... Something went wrong. The team could not be deleted."},
            notRemovedMember:{message:"Oops... Something went wrong. The team member could not be removed."},
            notUpdated:{message:"Oops... Something went wrong. The team could not be updated."}
        }

        this.properties =  new Properties("teams", headers, baseUrl);
        this.members = new TeamMembers(errors, headers, baseUrl)
        this.libraryPolicies = new LibraryPolicies(headers, baseUrl)
        this.errors=errors;
    }
    async all(account){
        if(!account || !account.uuid) {
            const error = this.errors.missingParams;
            error.path = "MeterianSDK.Teams.all"
            throw error
        }
        try{
            const teams = await fetch(`${this.baseUrl}/api/v1/accounts/${account.uuid}/teams`,{
                headers:this.headers.generate()
            })
            if(teams.status!=200) throw await teams.json();
            return await teams.json();
        }
        catch(e){
            console.log(e);
            throw e;
        }
    }

    async create(teamInfo){
        if(!teamInfo){
            const error = this.error.missingParams;
            error.path="MeterianSDK.Teams.create"
            throw error
        } 
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/teams`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify({
                    active: true,
                    name: teamInfo.name,
                    description: teamInfo.description
                })
            })
            if(response.status!=200) throw await response.json();
            return
        }
        catch(e){
            console.log(e);
            throw e;
        }

    }

    async update(teamUUID, teamInfo){
        if(!teamUUID || !teamInfo) {
            const error = this.error.missingParams;
            error.path="MeterianSDK.Teams.update"
            throw error
        } 
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/teams/${teamUUID}`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body:JSON.stringify({
                    active: teamInfo.active,
                    name: teamInfo.name,
                    description: teamInfo.description
                })
            })
            if(response.status!=200) throw await response.json();
            return
        }
        catch(e){
            console.log(e);
            throw e;
        }

    }

    async delete(teamUUID){
        if(!teamUUID) {
            const error = this.error.missingParams;
            error.path="MeterianSDK.Teams.delete"
            throw error
        } 
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/teams/${teamUUID}`,{
                method: "DELETE",
                headers:this.headers.generate()
            })
            if(response.status!=200) throw await response.json();
            return
        }
        catch(e){
            console.log(e);
            throw e
        }

    }
}


//License: PROPRIETARY
class Insights{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async get (accountUUID,vulnerabilityLevelQuery,dependencyType,sinceDaysAgo, nocache = false){
        try {
            const request = await fetch(`${this.baseUrl}/api/v2/accounts/${accountUUID}/insights/dependencies?${vulnerabilityLevelQuery}&all=${dependencyType}&sinceDaysAgo=${sinceDaysAgo}&nocache=${nocache}`, {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json();
            return request.json();
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }
}



// License: PROPRIETARY
class Policies{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async all(accountUUID){
        try{
            const policiesReq = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/policies/licenses`,{
                headers: this.headers.generate()
            })
            return await policiesReq.json();
        }
        catch(e){
            console.log(e);
            throw e
        }
    }
    async get(accountUUID, policyUUID){
        try{
            const policyReq = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/policies/licenses/${policyUUID}`,{
                headers: this.headers.generate()
            })
            return await policyReq.json()
        }
        catch(e){
            console.log(e);
            throw e
        }
    }
    async create(accountUUID, policy){
        try{
            const policyReq = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/policies/licenses`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(policy)
            })
            return await policyReq.json()
        }
        catch(e){
            console.log(e);
            throw e
        }
    }
    async update(accountUUID, policy){
        try{
            const policyReq = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/policies/licenses/${policy.uuid}`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(policy)
            })
            return await policyReq.json();
        }
        catch(e){
            console.log(e);
            throw e
        }
    }
    async delete(accountUUID, policyUUID){
        try{
            await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/policies/licenses/${policyUUID}`,{
                method: "DELETE",
                headers: this.headers.generate("application/json"),
            })
        }
        catch(e){
            console.log(e);
            throw e
        }
    }
}


// License: PROPRIETARY
class Utils {
    encodeString(raw) {
        return raw ? encodeURIComponent(raw.replace(/\|/g, "||").replace(/\//g, "|")) : "";
    }
    cleanEncodeURIComponent (value){
        try{
            return encodeURIComponent(decodeURIComponent(value))
        }
        catch(e){
            return encodeURIComponent(value)
        }
      }
}
const utils = new Utils()


// License: PROPRIETARY
class RkvistCretentialsController {
    //  ${this.baseUrl}/api/v1/integrations/rkvst/accounts/ffacde16-984b-44a1-b598-c994625e217b/credentials  GET cretentials
    //  ${this.baseUrl}/api/v1/integrations/rkvst/accounts/ffacde16-984b-44a1-b598-c994625e217b/credentials  SET cretentials
    //  ${this.baseUrl}/api/v1/integrations/rkvst/accounts/ffacde16-984b-44a1-b598-c994625e217b/credentials/check  TEST credentials
}

class RkvistProjectsController {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async getLinked(accountUuid) {
        try {
            const request = await fetch(`${this.baseUrl}/api/v1/rkvst/accounts/${accountUuid}/projects`, {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return await request.json()
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }

    async link(accountUuid, projectUuid, branch) {
        try {
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/rkvst/accounts/${accountUuid}/projects/${projectUuid}/${utils.cleanEncodeURIComponent(branch)}/link`, {
                headers: this.headers.generate(),
                method: "POST"
            })
            if (request.status != 200) throw await request.json()
            return await request.json()
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }

    async unlink(accountUuid, projectUuid, branch) {
        try {
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/rkvst/accounts/${accountUuid}/projects/${projectUuid}/${utils.cleanEncodeURIComponent(branch)}/unlink`, {
                headers: this.headers.generate(),
                method: "POST"
            })
            if (request.status != 200) throw await request.json()
            return await request.json()
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }

    async publish(accountUuid, projectUuid, branch) {
        try {
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/rkvst/accounts/${accountUuid}/projects/${projectUuid}/${utils.cleanEncodeURIComponent(branch)}/publish`, {
                headers: this.headers.generate(),
                method: "POST"
            })
            if (request.status != 200) throw await request.json()
            return 
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }
    async getHistory(accountUuid, projectUuid, branch) {
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/rkvst/accounts/${accountUuid}/projects/${projectUuid}/${utils.cleanEncodeURIComponent(branch)}/history`,{
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async publishSbomById(accountUuid, projectUuid, branch, id){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/rkvst/accounts/${accountUuid}/projects/${projectUuid}/${utils.cleanEncodeURIComponent(branch)}/sboms/${id}/publish`,{
                headers: this.headers.generate(),
                method: "POST"
            })
            if (request.status != 200) throw await request.json()
            return
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async withdrawSbomById(accountUuid, projectUuid, branch, id){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/rkvst/accounts/${accountUuid}/projects/${projectUuid}/${utils.cleanEncodeURIComponent(branch)}/sboms/${id}/withdraw`,{
                headers: this.headers.generate(),
                method: "POST"
            })
            if (request.status != 200) throw await request.json()
            return
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}

class RkvstConfigurationController{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async get(accountUuid){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/rkvst/accounts/${accountUuid}/credentials`,{
                headers:this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async set(accountUuid, credentials){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/rkvst/accounts/${accountUuid}/credentials`,{
                headers: this.headers.generate("application/json"),
                method: "POST",
                body: JSON.stringify(credentials)
            })
            if (request.status != 200 && request.status!=202) throw await request.json()
            return request.status==200
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async test(accountUuid, credentials){
        try{
            const body = credentials? JSON.stringify(credentials) : ""
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/rkvst/accounts/${accountUuid}/credentials/check`,{
                headers: this.headers.generate("application/json"),
                method: "POST",
                body
            })
            if (request.status != 200 && request.status != 400) throw await request.json()
            return request.status == 200
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}

class RkvstIntegration {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        this.projects = new RkvistProjectsController(headers, baseUrl)
        this.configuration = new RkvstConfigurationController(headers, baseUrl)
    }
}



// License: PROPRIETARY
class DatadogIntegration{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async checkCredentials(accountUUID, credentials){
        try{
            const result = await fetch(`${this.baseUrl}/api/v1/integrations/datadog/accounts/${accountUUID}/credentials-check`,{
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(credentials),
                method: "POST"
            })
            if (result.status!=200) throw new Error("Credentials not valid")
            return 
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async getHistory(accountUUID){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/datadog/accounts/${accountUUID}/history`,{
                headers: this.headers.generate()
            })
            if(request.status!=200) throw await request.json()
            return request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async sendMetricsNow(accountUUID){
        try{
            await fetch(`${this.baseUrl}/api/v1/integrations/datadog/accounts/${accountUUID}/send-now`,{
                headers: this.headers.generate(),
                method: "POST"
            })
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async getConfig(accountUUID){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/datadog/accounts/${accountUUID}/setup`,{
                headers: this.headers.generate()
            })
            if (request.status!=200) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async setConfig(accountUUID, config){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/datadog/accounts/${accountUUID}/setup`,{
                headers: this.headers.generate("application/json"),
                method: "POST",
                body: JSON.stringify(config)
            })
            if (request.status!=200 && request.status!=202) throw await request.json()
            return
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}




// License: PROPRIETARY

class JiraCredentialsController {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async get(accountUuid){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/jira/accounts/${accountUuid}/config`,{
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async set(accountUuid, config){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/jira/accounts/${accountUuid}/config`,{
                headers: this.headers.generate("application/json"),
                method: "POST",
                body: JSON.stringify(config)
            })
            if (request.status != 200 && request.status!=202) throw await request.json()
            return request.status==200
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async test(accountUuid, config){
        try{
            const body = config? JSON.stringify(config) : ""
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/jira/accounts/${accountUuid}/config/check`,{
                headers: this.headers.generate("application/json"),
                method: "POST",
                body
            })
            if (request.status != 200 && request.status != 400) throw await request.json()
            return request.status == 200
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}

class JiraProjectsController {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.issues = new JiraIssues(headers, baseUrl)
    }

    async get(accountUuid, projectUuid){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/jira/accounts/${accountUuid}/projects/${projectUuid}/config`,{
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async link(accountUuid, projectUuid, jiraProjectInfo) {
        JSON.stringify(jiraProjectInfo)
        try {
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/jira/accounts/${accountUuid}/projects/${projectUuid}/config`, {
                headers: this.headers.generate("application/json"),
                method: "POST",
                body: JSON.stringify(jiraProjectInfo)
            })
            if (request.status != 200) throw await request.json()
            return 
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }

    async getProjects(accountUuid) {
        try {
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/jira/accounts/${accountUuid}/jiraprojects`, {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return await request.json()
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }

    async getProjectMeta(accountUuid, jiraProjectKey) {
        try {
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/jira/accounts/${accountUuid}/jiraprojects/${jiraProjectKey}/issues/meta`, {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return await request.json()
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }

    async check(accountUuid, projectUuid, config) {
        try {
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/jira/accounts/${accountUuid}/projects/${projectUuid}/config/check`, {
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(config)
            })
            if (request.status != 200 && request.status != 400) throw await request.json()
            return request.status == 200
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }
}

class JiraIssues{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        this.headers = headers ||  new Headers( AuthTypes.BEARER)
    }
    async list(accountUuid, projectUuid){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/jira/accounts/${accountUuid}/projects/${projectUuid}/issues`, {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }   
    }
    async create(accountUuid, projectUuid, issue){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/integrations/jira/accounts/${accountUuid}/projects/${projectUuid}/issues`, {
                headers: this.headers.generate("application/json"),
                method: "POST",
                body: JSON.stringify(issue)
            })
            if (request.status != 200 && request.status!=201) throw await request.json()
            return request.status==201
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    convertToMap(issues){
        const byAdvice = {}
        const byIssueKey = {}
        const byCve = {}
        for(const issue of issues.issues){
            byAdvice[issue.mappings.uuid] = issue
            byCve[issue.mappings.cve] = issue
            byIssueKey[issue.key] = issue
        }
        return {
            byAdvice, byIssueKey, byCve
        }
    }
}

class JiraIntegration {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        this.projects = new JiraProjectsController(headers, baseUrl)
        this.configuration = new JiraCredentialsController(headers, baseUrl)
        
    }
}


// License: PROPRIETARY
class Integrations{
    constructor(features, headers, baseUrl = ""){
        this.baseUrl = baseUrl
        this.features = features
        this.headers = headers
    }
    
    init(){
        this.rkvst = this.features.list.rkvst ? new RkvstIntegration(this.headers, this.baseUrl) : null
        this.datadog = this.features.list.datadog ? new DatadogIntegration(this.headers, this.baseUrl) : null
        this.jira = this.features.list.jira ? new JiraIntegration(this.headers, this.baseUrl) : null
    }
}



class SDKErrorBoundary {
    async wrap(fn) {
        try{
            return await fn()
        }
        catch(e){
            if(e.json) {
                throw await e.json()
            }
            throw e
        }
    }
}


//License: PROPRIETARY

class AccountExclusions{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.errorBoundary = new SDKErrorBoundary()
    }
    async get(accountUUID, includeExpired = false){

        return await this.errorBoundary.wrap(async()=>{
            const request = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/exclusions?includeExpired=${includeExpired}`, {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json();
            return await request.json();
        })
    }

    set(accountUUID,exclusions){
        console.log(JSON.stringify(exclusions))
        const setExclusion = async (domain)=>{
            return await this.errorBoundary.wrap(async()=>{
                const request = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/exclusions?domain=${domain}`, {
                    method: "POST",
                    headers: this.headers.generate("application/json"),
                    body: JSON.stringify(exclusions)
                })
                if (request.status != 200) throw await request.json();
                return await request.json();
            })
        }
        return{
            security: async()=>{
                return await setExclusion("security")
            },
            stability: async()=>{
                return await setExclusion("stability")
            },
            licensing: async()=>{
                return await setExclusion("licensing")
            }
        }
        
    }

    delete(accountUUID,exclusion){
        const removeExclusion = async(domain)=>{
            return await this.errorBoundary.wrap(async()=>{
                const request = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/exclusions?domain=${domain}`, {
                    method: "DELETE",
                    headers: this.headers.generate("application/json"),
                    body: JSON.stringify(exclusion)
                })
                if (request.status != 200) throw await request.json();
                this.currentlyExcluding = "";
                return await request.json();
            })
        }
        return{
            security: async()=>{
                return await removeExclusion("security")
            },
            stability: async()=>{
                return await removeExclusion("stability")
            },
            licensing: async()=>{
                return await removeExclusion("licensing")
            }
        }
    }
}



// License: PROPRIETARY
class AssistanceToken{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async get(accountUUID){
        try{
            const tokenReq = await fetch(`${this.baseUrl}/api/v1/accounts/`+accountUUID+"/support-token",{
                headers: this.headers.generate("application/json")
            })
            if(tokenReq.status!=200) throw await tokenReq.json();
            try{
                const assistance = await tokenReq.json();
                const expired = Date.now()-assistance.expiresAt > 0
                if(expired) throw new Error();
                return assistance
            }
            catch(e){
                return {}
            }
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async generate(accountUUID){
        try{
            const tokenReq = await fetch(`${this.baseUrl}/api/v1/accounts/`+accountUUID+"/support-token",{
                method: "POST",
                headers: this.headers.generate("application/json")
            })
            if(tokenReq.status!=200) throw await tokenReq.json();
            try{
                const assistance = await tokenReq.json();
                return assistance
            }
            catch(e){
                return {}
            }
        }
        catch(e){
            console.log(e);
            throw(e)
        }
    }
}


// License: PROPRIETARY
class Tokens{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)

        this.errors={
            missingParams:{message:"Some parameters necessary for the request are missing."}
        }
    }
    async all(accountUUID, includes){

        if(!accountUUID || !accountUUID.length){
            const error = this.errors.missingParams;
            error.path="MeterianSDK.accounts.tokens.all"
            throw error
        }
        try{
            let url = `${this.baseUrl}/api/v1/accounts/${accountUUID}/tokens`
            if(includes) url += `?includes=${encodeURIComponent(includes)}`
            const response = await fetch(url,{
                headers: this.headers.generate()
            })
            if(response.status!=200) throw await response.json();
            return await response.json()
        }
        catch(e){
            console.log(e);
            throw e
        }

    }

    async create(token){
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/tokens`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(token)
            })
            if(response.status!=200) throw await response.json();
            return await response.json()
        }
        catch(e){
            console.log(e);
            throw e
        }
    }

    async update(tokenUuid, token){
        try{
            const response = await fetch(`${this.baseUrl}/api/v1/tokens/${tokenUuid}`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(token)
            })
            if(response.status!=200) throw await response.json();
            return await response.json()
        }
        catch(e){
            console.log(e);
            throw e
        }
    }

}





class AccountConfiguration{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async get(accountUuid){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUuid}/configuration`,{
                headers: this.headers.generate()
            })
            if(request.status!=200) throw await request.json();
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async set(accountUuid, content){
        try{
            const updateRequest = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUuid}/configuration`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(content)
            })
            if(updateRequest.status!=200) throw updateRequest.json();
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}


//License: PROPRIETARY
class Credentials{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async getStatus(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/credentials/status`)
            if (!request.ok) throw await request.json()
            const response = await request.json()
            return response
        }
        catch(e){
            console.log(e)
            return {validation: true}
        }
    }

    async login(email, password){
        try{
            const url = `${this.baseUrl}/api/v1/credentials/login`
            const request = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ email, password })
            })
            
            if (!request.ok) throw await request.json()
            const response = await request.json()
            return response
        }
        catch(e){
            if(e.status==428) throw { status: 428 , message: ""}
            console.log(e)
            throw await e.json()
        }
    }

    async signup(email, password, name){
        try{
            if (!name || !name.length) name = email.split("@")[0]
            const url = `${this.baseUrl}/api/v1/credentials/register`
            const request = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, password, name })
            })
            if (!request.ok) throw await request.json()
            const response = await request.json()
            return response
        }
        catch(e){
            console.log(e)
            throw await e.json()
        }
    }

    async requestPasswordReset(email){
        try{
            const url = `${this.baseUrl}/api/v1/credentials/forget?email=${encodeURIComponent(email)}`
            const request = await fetch(url, {
                method: "POST"
            })
            if (!request.ok) throw await request.json()
            const response = await request.json()
            return response
        }
        catch(e){
            console.log(e)
            throw await e.json()
        }
    }

    async logout(){
        try{
            const url = `${this.baseUrl}/api/v1/credentials/logout`
            const request = await fetch(url, {
                method: "POST",
                headers: this.headers.generate()
            })
            if (!request.ok) throw await request.json()
            return request
        }
        catch(e){
            throw e
        }
    }
}


// License: PROPRIETARY


class Accounts{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.features = new Features(headers, baseUrl);
        this.plans = new Plans(headers, baseUrl);
        this.properties = new Properties("accounts", headers, baseUrl);
        this.members = new Members(headers, baseUrl);
        this.teams = new Teams(headers, baseUrl)
        this.insights = new Insights(headers, baseUrl);
        this.policies=new Policies(headers, baseUrl)
        this.integrations = new Integrations(this.features, headers, baseUrl)
        this.exclusions=new AccountExclusions(headers, baseUrl);
        this.tokens = new Tokens(headers, baseUrl)
        this.configuration = new AccountConfiguration(headers, baseUrl)
        this.credentials = new Credentials(headers, baseUrl)
          
    }


    async all(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/accounts`,{
                headers: this.headers.generate("application/json")
            })
            return await request.json();
        }
        catch(e){
            console.log(e);
            throw await e.json();
        }
    }


    async get(accountUUID){
        if(!accountUUID) throw {message: "No account uuid has been specified", path: "MeterianSDK.Accounts.get" };
        try{
            const options = accountUUID == "default"? {} : {headers: this.headers.generate()}
            accountUUID = accountUUID == "default"? "defadefa-defa-defa-defa-defadefadefa" : accountUUID
            const request = await fetch(`${this.baseUrl}/api/v1/accounts/`+accountUUID, options)
            return await request.json();
        }
        catch(e){
            console.log(e);
            throw await e.json();
        }
    }

    async getFromMember(memberEmail) {
        if (!memberEmail || !memberEmail.length) throw {message: "Email address invalid or missing"}
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/accounts?q=member_email${utils.cleanEncodeURIComponent("="+memberEmail)}`,{
                headers: this.headers.generate()
            }) 
            const accounts = await request.json()
            return accounts[0]
        }
        catch(e){
            console.log(e)
            throw await e.json()
        }
    }

    async status(account,activate=false, setMeterianXAuth=true) {
        if(!account || !account.uuid) throw {message: "No account has been specified", path: "MeterianSDK.Accounts.status" }
        try{
            await fetch(`${this.baseUrl}/api/v1/accounts/` + account.uuid + "/activation?active="+activate,{
                method: "POST",
                headers:this.headers.generate(null, setMeterianXAuth)
            })
            return;
        }
        catch(e){
            console.log(e);
            throw await e.json();
        }
    };

    async create(accountInfo){
        if(!accountInfo || !accountInfo.name || !accountInfo.name.length || !accountInfo.email || !accountInfo.email.length) throw {message: "Required information not provided.", path: "MeterianSDK.Accounts.create" } 
        try{
            await fetch(`${this.baseUrl}/api/v1/accounts`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(accountInfo)
            })
            return;
        }
        catch(e){
            console.log(e);
            throw await e.json();
        } 
    }
    async update(account,newInfo) {
        if(!account || !account.uuid) throw {message: "No account has been specified", path: "MeterianSDK.Accounts.update" } 
        try{
            await fetch(`${this.baseUrl}/api/v1/accounts/` + account.uuid,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(newInfo)
            })
            return;
        }
        catch(e){
            console.log(e);
            throw await e.json();
        }

    };

    async delete(uuid, check) {
        if(!uuid || !uuid.length) throw {message: "No account has been specified", path: "MeterianSDK.Accounts.delete" } 
        try{
            await fetch(`${this.baseUrl}/api/v1/accounts/` + uuid +"?check="+check,{
                method: "DELETE",
                headers: this.headers.generate()
            })
            return;
        }
        catch(e){
            console.log(e);
            throw await e.json();
        }

    };

    async setExperimental(account, experimental){
        if(!account || !account.uuid) throw {message: "No account has been specified", path: "MeterianSDK.Accounts.setExperimental" } 
        try{
            await fetch(`${this.baseUrl}/api/v1/accounts/${account.uuid}/properties/experimental`,{
                headers: this.headers.generate("application/json"),
                method: "POST",
                body: JSON.stringify(experimental)
            })
            return;
        }
        catch(e){
            console.log(e);
            throw await e.json();
        }
    
    }

    async setOrganizations(account,organizations){
        if(!account || !account.uuid) throw {message: "No account has been specified", path: "MeterianSDK.Accounts.setOrganizations" } 

        try{
            await fetch(`${this.baseUrl}/api/v1/accounts/${account.uuid}/properties/autogroupings`,{
                method: 'POST',
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(organizations)
            })
            return
        }
        catch(e){
            console.log(e);
            throw await e.json();
        }
    }

    assistanceToken(account){
        if(!account) throw{
            message: "No account has been specified" , path: "MeterianSDK.Accounts.assistanceToken"
        }
        if(!account.admin) throw{
            message: "Unauthorized", path: "MeterianSDK.Accounts.assistanceToken"
        }
        
        return new AssistanceToken();
    }

    async paygTokens(account){
        if(!account) throw{
            message: "No account has been specified" , path: "MeterianSDK.Accounts.paygTokens"
        }

        try{
            const request =  await fetch(`${this.baseUrl}/api/v1/accounts/${account.uuid}/payg/tokens`,{
                headers: this.headers.generate()
            })
            if(!request.ok) throw await request.json()
            return await request.text()
        }
        catch(e){
            console.error(e)
            throw e
        }
    }
    

}



// License: PROPRIETARY
class Role{
    normalize(role, allScopes = false){
        let scopes = ["tokens", "projects", "policies", "tags"]
        if(allScopes) scopes = [...Object.keys(role)]
        for(const scope of scopes){
            for(const permission in role[scope]){
                if (role[scope][permission]){
                    this[scope][permission] = true
                }
            }
        }
    }
}



// License: PROPRIETARY
class RoleAdministrator extends Role{
    constructor(){
        super()
        this.tokens = {
            read_any: true,
            create_any: true,
            edit_any: true,
            delete_any: true,
            read_self: true,
            create_self: true,
            edit_self: true,
            delete_self: true,
            rbac: true          // token-specific: may create/manage RBAC tokens
        }
        this.projects = {
            read: true,
            edit: true,
            delete: true
        }
        this.tags = {
            read: true,
            delete: true,
            edit: true
        }
        this.insights = {
            read: true,
            edit: true
        }
        this.teams = {
            read: true,
            create: true,
            edit: true,
            delete: true
        }
        this.members = {
            read: true,
            edit: true,
            delete: true
        }
        this.policies = {
            read: true,
            edit: true,
            delete: true
        }
        this.isaac = {
            read: true,
            edit: true
        }
        this.account = {
            read: true,
            edit: true,
            disable: true,
            support: true
        }
        this.configuration = {
            read: true,
            edit: true
        }
        this.reports = {
            read: true,
            edit: true,
            delete: true
        }
    }

}

// License: PROPRIETARY
class RoleCollaborator extends Role {
    constructor() {
        super()
        this.tokens = {
            read_any: false,
            create_any: false,
            edit_any: false,
            delete_any: false,
            read_self: true,
            create_self: true,
            edit_self: true,
            delete_self: true,
            rbac: false         // token-specific: may not create/manage RBAC tokens
        }
        this.projects = {
            read: true,
            edit: true,
            delete: false
        }
        this.tags = {
            read: true,
            edit: false,
            delete: false
        }
        this.insights = {
            read: true,
            edit: false
        }
        this.teams = {
            read: true,
            create: false,
            edit: false,
            delete: false
        }
        this.members = {
            read: true,
            edit: false,
            delete: false
        }
        this.policies = {
            read: true,
            edit: false,
            delete: false
        }
        this.isaac = {
            read: true,
            edit: false
        }
        this.account = {
            read: true,
            edit: false,
            disable: false,
            support: true
        }
        this.configuration = {
            read: false,
            edit: false
        }
        this.reports = {
            read: true,
            edit: true,
            delete: false
        }
    }
}


// License: PROPRIETARY
class RoleViewer extends Role {
    constructor() {
        super()
        this.tokens = {
            read_any: false,
            create_any: false,
            edit_any: false,
            delete_any: false,
            read_self: true,
            create_self: true,
            edit_self: true,
            delete_self: true,
            rbac: false         // token-specific: may not create/manage RBAC tokens
        }
        this.projects = {
            read: true,
            edit: false,
            delete: false
        }
        this.tags = {
            read: true,
            edit: false,
            delete: false
        }
        this.insights = {
            read: true,
            edit: false
        }
        this.teams = {
            read: true,
            create: false,
            edit: false,
            delete: false
        }
        this.members = {
            read: true,
            edit: false,
            delete: false
        }
        this.policies = {
            read: true,
            edit: false,
            delete: false
        }
        this.isaac = {
            read: true,
            edit: false
        }
        this.account = {
            read: true,
            edit: false,
            disable: false,
            support: false
        }
        this.configuration = {
            read: false,
            edit: false
        }
        this.reports = {
            read: true,
            edit: false,
            delete: false
        }
    }
    enforceStrictView() {
        this.tokens.create_self = false
        this.tokens.edit_self = false
        this.tokens.delete_self = false
    }
}

// License: PROPRIETARY

class RoleTeamAdministrator extends RoleAdministrator{
    constructor(){
        super()
        this.tags = {
            read: true,
            delete: false,
            edit: false
        }
        this.insights = {
            read: true,
            edit: false
        }
        this.teams = {
            read: true,
            create: false,
            edit: true,
            delete: false
        }
        this.isaac = {
            read: true,
            edit: false
        }
        this.account = {
            read: true,
            edit: false,
            disable: false,
            support: false
        }
        this.configuration = {
            read: false,
            edit: false
        }
        this.reports = {
            read: true,
            edit: true,
            delete: true
        }
        this.policies = {
            read: true,
            edit: true,
            delete: true
        }
    }

}


// License: PROPRIETARY
class RoleTeamCollaborator extends RoleCollaborator {
    constructor() {
        super()
    }
}


// License: PROPRIETARY
class RoleTeamViewer extends RoleViewer {
    constructor() {
        super()
    }
}



// License: PROPRIETARY
class RoleAssigner{
    assign(role, team = false, enforceStrictViewer = false){
        if(role.toLowerCase()=="administrator"){
            return team ? this.TeamAdministrator() : this.Administrator()
        }
        if(role.toLowerCase()=="collaborator"){
            return team ? this.TeamCollaborator() : this.Collaborator()
        }
        if(role.toLowerCase()=="viewer"){
            const assigned = team ? this.TeamViewer() : this.Viewer()
            if(enforceStrictViewer) assigned.enforceStrictView()
            return assigned
        }
    }
    Administrator(){
        return new RoleAdministrator()
    }
    TeamAdministrator(){
        return new RoleTeamAdministrator()
    }
    Collaborator(){
        return new RoleCollaborator()
    }
    TeamCollaborator(){
        return new RoleTeamCollaborator()
    }
    Viewer(){
        return new RoleViewer()
    }
    TeamViewer(){
        return new RoleTeamViewer()
    }

}


// License: PROPRIETARY
class Users{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        this.roleAssigner = new RoleAssigner()
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async me(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/users/me`,{
                headers: this.headers.generate()
            })
            if(!request) throw new Error("Seem like fetch did not work, request is undefined")
            return await request.json();
        }
        catch(e){
            console.log(e)
            throw e
        }
    }


}


// License: PROPRIETARY
class ProjectExclusions{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async create(uuid, branch, exclusion){
        try{
            const request = await fetch(`${this.baseUrl}/api/v2/exclusions/${uuid}/${utils.encodeString(branch)}`,{
                headers: this.headers.generate("application/json"),
                method: "POST",
                body: JSON.stringify(exclusion)
            })
            if(!request.ok)throw await request.json()
            return
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async get(uuid, branch, includeExpired = false){
        try{
            const request = await fetch(`${this.baseUrl}/api/v2/exclusions/${uuid}/${utils.encodeString(branch)}?expanded=true&includeExpired=${includeExpired}`,{
                headers: this.headers.generate()
            })
            if(!request.ok) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async delete(uuid, branch, exclusion){
        try{
            const request = await fetch(`${this.baseUrl}/api/v2/exclusions/${uuid}/${utils.encodeString(branch)}/${exclusion}`,{
                method: 'DELETE',
                headers: this.headers.generate()
            })
            if(!request.ok) throw await request.json()
            return
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}



// License: PROPRIETARY

class Projects{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.exclusions = new ProjectExclusions(headers, baseUrl)
    }
    async all(query) {

        try{
            const reportsRequest = await fetch(`${this.baseUrl}/api/v2/reports?sinceDaysAgo=${query.sinceDaysAgo}&nocache=${query.nocache}`, {
                headers: this.headers.generate()
            })
            if (reportsRequest.status != 200){
                throw await reportsRequest.json();
            } 
            return await reportsRequest.json();
        }
        catch(e) {
            console.log(e);
            throw e;
        }
    }
    async allV3(query) {

        try{
            const reportsRequest = await fetch(`${this.baseUrl}/api/v3/reports?sinceDaysAgo=${query.sinceDaysAgo}&nocache=${query.nocache}`, {
                headers: this.headers.generate()
            })
            if (reportsRequest.status != 200){
                throw await reportsRequest.json();
            } 
            return await reportsRequest.json();
        }
        catch(e) {
            console.log(e);
            throw e;
        }
    }
    async count(accountUUID) {
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/projects/count`,{
                headers: this.headers.generate()
            })
            if (request.status != 200){
                throw await request.json();
            } 
            return await request.json();
        }
        catch(e) {
            console.log(e);
            throw e;
        }
    }
    async allAccountProjects(accountUUID){
        try{
            const reportsRequest = await fetch(`${this.baseUrl}/api/v1/accounts/${accountUUID}/projects`, {
                headers: this.headers.generate()
            })
            if (reportsRequest.status != 200){
                throw await reportsRequest.json();
            } 
            return await reportsRequest.json();
        }
        catch(e) {
            console.log(e);
            throw e;
        }
    }

    async get(projectUUID){
        if(!projectUUID) throw {message: "No project uuid has been specified", path: "MeterianSDK.Projects.get" };
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/projects/`+projectUUID,{
                headers: this.headers.generate()
            })
            return await request.json();
        }
        catch(e){
            console.log(e);
            throw await e.json();
        }
    }


    async summaries(projectUUID,sinceDaysAgo){
        try{
            const infoProjectRequest = await fetch(`${this.baseUrl}/api/v1/reports/`+projectUUID+"/summary?sinceDaysAgo="+sinceDaysAgo,{
                headers: this.headers.generate()
            })
            if (infoProjectRequest.status != 200) {
                throw await infoProjectRequest.json();
            }
            return await infoProjectRequest.json();
        }   
        catch(e){
            console.log(e);
            throw e;

        }
    }


    async createEmptyProject(name){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/projects`,{
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify({url: name})
            })
            if ( request.status != 200 ) {
                throw await request.json()
            }
            return await request.json()

        }
        catch(e){
            console.log(e);
            throw e
        }
    }

    async createProjectViaSbom(isExistingProject, projectUuid, projectUrl, projectBranch, teamUuid, rawFormData){
        console.log({rawFormData})
        const formData = new FormData(rawFormData);
        if(isExistingProject) return await this.updateViaSbom(projectUuid, projectBranch, teamUuid, formData)
        else return await this.createViaSbom(projectUrl, projectBranch, teamUuid, formData)
    }

    async updateViaSbom(projectUuid, projectBranch, teamUuid, formData){
        try{
            let url = `${this.baseUrl}/api/v1/uploads/${projectUuid}/sbom-cdx.json?branch=${projectBranch}`
            if(teamUuid && teamUuid.length) url += `&teamUuid=${teamUuid}`
            const request = await fetch(url, {
                method: "POST",
                headers: this.headers.generate(),
                body: formData
            })
            if (request.status != 200) {
                throw await request.json()
            }
            return await request.json()

        }
        catch(e){
            if(e?.json) throw await e.json()
            console.log(e);
            throw e
        }

    }

    async createViaSbom( projectUrl, projectBranch, teamUuid, formData){
        let url = `${this.baseUrl}/api/v1/uploads/new/sbom-cdx.json?url=${projectUrl}&branch=${projectBranch}`
        if(teamUuid && teamUuid.length) url+= `&teamUuid=${teamUuid}`
        try{
            const request = await fetch(url, {
                method: "POST",
                headers: this.headers.generate(),
                body: formData
            })
            if (request.status != 200) {
                throw await request.json()
            }
            return await request.json()

        }
        catch(e){
            console.log(e);
            if(e?.json) throw await e.json()
            throw e
        }
    }
    

}


//License: PROPRIETARY
class Dependencies{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async get(language, dependency, version="0", queryParams={}) {
        try {
            const query = []
            const queryParamsToKeep = ["from", "to"]
            for(const key in queryParams){
                if(!queryParamsToKeep.includes(key) && (!queryParams[key] || !queryParams[key].length )) continue 
                query.push(`${key}=${queryParams[key]}`)
            }

            const request = await fetch(`${this.baseUrl}/api/v1/dependency/${encodeURIComponent(language)}/${encodeURIComponent(dependency)}/${encodeURIComponent(version)}?${query.join("&")}` , {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json();
            return await request.json();
        }
        catch (e) {
            console.log(e);
            throw e
        }
    }
    async nextSafe(language, dependency, version="0"){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/dependency/${encodeURIComponent(language)}/${encodeURIComponent(dependency)}/${encodeURIComponent(version)}/next`, {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json();
            return await request.json();
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async registryUrl(language, name, version, redirect = false) {
        try{
            name = decodeURIComponent(name)
            name = name.replace(/\//g, "|")
            if(version == "-" || version == "--" || version == "") version = "0"
            if(window && window.location && redirect) {
                return window.location.replace(`${this.baseUrl}/api/v1/components/${encodeURI(language)}/${encodeURI(name)}/${encodeURI(version)}/registryWebUrl?redirect=true`)
            }
            const request = await fetch(`${this.baseUrl}/api/v1/components/${encodeURI(language)}/${encodeURI(name)}/${encodeURI(version)}/registryWebUrl`)
            if (request.status != 200) throw await request.json();
            return await request.text();
        }
        catch(e){
            console.log(e)
            throw await e.text()
        }
    }
    async licenses(language, name, version){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/licenses/library/${encodeURIComponent(language)}/${encodeURIComponent(name)}/${encodeURIComponent(version)}`, {  
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json();
            return await request.json();
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}



// License: PROPRIETARY

class Badges{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async getMany(domains, pid, branch, reportUuid){
        const badges = {}
        for (const entry of domains){
            const badge = await this.get(entry.domain, pid, branch, entry.score, reportUuid)
            badges[entry.domain] = badge
        }
        return badges
    }

    async get(domain, pid, branch, score, reportUuid=null){
        let url = `${this.baseUrl}/api/v2/badges/${pid}/${domain}?branch=${utils.cleanEncodeURIComponent(branch)}&b64&slug=${Date.now()}`
        if(reportUuid) url+="&reportUuid="+reportUuid
        const badge = await this.loadImage(url);
        return badge

    }
    async loadImage(url){
        try{
            return await new Promise(async(resolve, reject)=>{
                setTimeout(reject,3*1000);
                const data= await fetch(url,{ headers: this.headers.generate()});
                if(data.status!==200) throw new Error("Badge not available")
                const svg= await data.text();
                resolve(this.asEmbeddedImage(svg));
            })
        }
        catch(e){
            return null
        }
    }
    asEmbeddedImage(svgImageString){
        var encoded = svgImageString.replace(/\n+/g, '');
        encoded = utils.cleanEncodeURIComponent(encoded)
            .replace(/%20/g, ' ')
            .replace(/%3D/g, '=')
            .replace(/%3A/g, ':')
            .replace(/%2F/g, '/')
            .replace(/%22/g, "'");

        return 'data:image/svg+xml,' + encoded;
    }
}



// License: PROPRIETARY
class Reports{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.badges = new Badges(headers, baseUrl)
    }
    async get(pid, branch=null, reportId=null){
        try{
            if(!pid) throw {message: "No project uuid has been specified", path: "MeterianSDK.Reports.get" };
            let url = `${this.baseUrl}/api/v1/reports/${pid}/full${reportId ? "/"+reportId : ""}?includes=expanded-licenses`;
            if(!reportId && branch){
                url += `&branch=${utils.cleanEncodeURIComponent(branch)}`
            } 

            const request= await fetch(url,{headers: this.headers.generate()})
            if(request.status!==200) throw await request.json()
            const report= await request.json();
            return report;
        }
        catch(e){
            console.log(e)
            if(e?.json) throw await e.json()
            throw e
        }
    }

    async refresh(pid, branch){
        try{
            const refreshRequest = await fetch(`${this.baseUrl}/api/v1/pull-server/projects/${pid}?branch=${utils.cleanEncodeURIComponent(branch)}`,{
                method: 'POST',
                headers: this.headers.generate()
            })
            if(refreshRequest.status!==200) throw new Error();
            return true
        }
        catch(e){
            return false
        }
    }

    async recompute(pid,branch){
        try{
            const recomputeRequest= await fetch(`${this.baseUrl}/api/v1/reports/${pid}/full?branch=${utils.cleanEncodeURIComponent(branch)}`,{
                method: 'POST',
                headers: this.headers.generate()
            })
            if(recomputeRequest.status!==200) throw await recomputeRequest.json();
            return await recomputeRequest.json();
        }
        catch(e){
            throw e
        }
    }
}



// License: PROPRIETARY
class Tags{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async all(query={}){
        try{
            query = Object.keys(query).map(q=>q+"="+query[q]).join("&")
            if (query.length) query="?"+query
            const request = await fetch(`${this.baseUrl}/api/v1/accounts/me/tags`+query,{
                headers: this.headers.generate()
            })
            if ( request.status!=200 ){
                throw await request.json()
            }
            return await request.json()
        }
        catch(e){
            console.log(e);
            throw e
        }
    }

    async create(tag){
        
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/accounts/me/tags`, {
                "method": "POST",
                "headers": this.headers.generate("application/json"),
                "body": JSON.stringify(tag)
            })
            if ( request.status!=200 ) {
                throw await request.json()
            }
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async update(label, tag){
        
        
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/accounts/me/tags/`+label, {
                "method": "POST",
                "headers": this.headers.generate("application/json"),
                "body": JSON.stringify(tag)
            })
            if ( request.status!=200 ) {
                throw await request.json()
            }
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async delete(tag){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/accounts/me/tags/`+tag, {
                "method": "DELETE",
                "headers": this.headers.generate("application/json")
            })
            if ( request.status!=200 ) {
                throw await request.json()
            }
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}




// License: PROPRIETARY
class SiteServerCli{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async get(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/cli`,{
                headers: this.headers.generate()
            })
            if ( request.status != 200 ) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}


// License: PROPRIETARY
class SiteServerDatabases{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async get(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/databases`,{
                headers: this.headers.generate()
            })
            if ( request.status != 200 ) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async sync(id){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/databases/`+id+"/sync",{
                method: "POST",
                headers: this.headers.generate()
            })
            if ( request.status != 200 ) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async getSyncStatus(id){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/databases/`+id+"/sync",{
                headers: this.headers.generate()
            })
            if ( request.status != 200 ) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

}


// License: PROPRIETARY
class SiteServerNetwork{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async status(){
        try{
            const request = await fetch(`${this.baseUrl}/admin/server/site/network`,{
                headers: this.headers.generate()
            })
            if ( request.status != 200 ) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

}


// License: PROPRIETARY
class SiteServerLicenses{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async get(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/license`,{
                headers: this.headers.generate()
            })
            if ( request.status != 200 ) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async activate(license){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/license/`+license+"/activate",{
                headers: this.headers.generate(),
                method: "POST"
            })
            if ( request.status != 200 ) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async deactivate(license){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/license/`+license+"/release",{
                headers: this.headers.generate(),
                method: "POST"
            })
            if ( request.status != 200 ) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async stats(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/admin/ag/site-stats`,{
                headers: this.headers.generate(),
                method: "GET"
            })
            if ( request.status != 200 ) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}


// License: PROPRIETARY
class SiteServer{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        this.licenses = new SiteServerLicenses(headers, baseUrl)
        this.databases = new SiteServerDatabases(headers, baseUrl)
        this.cli = new SiteServerCli(headers, baseUrl)
        this.network = new SiteServerNetwork(headers, baseUrl)
    }
}


// License: PROPRIETARY

class ServicesAdmin{
    constructor(baseUrl = "" ){
        this.baseUrl = baseUrl
    }
    async version(service) {
        try {
            const req = await fetch(`${this.baseUrl}/admin/server/${service}/version`);
            if (!req.ok) throw req;
            const text = await req.text();
            const versionFileAsJson = {}
            for ( const line of text.split("\n") ) {
                const separators = [":", "="]
                const separator = separators.find(separator => line.includes(separator))
                if(!separator) continue
                const [label, value] = line.split(separator);
                versionFileAsJson[label.trim().toLowerCase().split(" ").join("_")] = value.trim()
            }
            return versionFileAsJson;
        } catch (e) {
            return {};
        }
    }

    async healthcheck(service) {
        try{
            const req = await fetch(this.getHealthcheckUrl(service))
            if(!req.ok) throw new Error()
            return true
        }
        catch(e){
            return false
        }
    }
    getHealthcheckUrl(service){
        return `${this.baseUrl}/admin/server/${service}/healthcheck`
    }
    async healthcheckV2(service) {
        try{
            const req = await fetch(this.getHealthcheckUrl(service))
            if(!req.ok) throw req
            const details = await this.extractResponseBody(req)
            return {
                healthy: true,
                details
            }
            
        }
        catch(e){
            const details =  await this.extractResponseBody(e)
            return {
                healthy: false,
                details
            }
        }
    }

    async extractResponseBody (request) {
        try{
            return await request.json()
        }
        catch(e){
            return {message: "Unable to obtain reason for failure"}
        }
    }

    
}


// License: PROPRIETARY
class Isaac {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async getPolicies() {
        try {
            const request = await fetch(`${this.baseUrl}/api/v1/isaac/me/policies`, {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return request.json()
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }
    async updatePolicy(policy) {
        try {
            const request = await fetch(`${this.baseUrl}/api/v1/isaac/me/policies/${policy.sysid}`, {
                headers: this.headers.generate("application/json"),
                method: "POST",
                body: JSON.stringify({ enabled: policy.enabled, severity: policy.severity, tags: policy.tags })
            })
            if (request.status != 200) throw await request.json()
            return
        }
        catch (e) {
            console.log(e)
            throw e
        }
    }
}



// License: PROPRIETARY
class Allerta{
    constructor(baseUrl = ""){
        this.baseUrl = baseUrl
    }
    
    async daily(){
        try{            
            const request = await fetch(this.baseUrl+"/stats/allerta.json")
            if(!request.ok) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async getByDate(date) {
        try{            
            const request = await fetch(this.baseUrl+`/stats/allerta_${date}.json`)
            if(!request.ok) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.error(e)
            return null
        }
    }
}



// License: PROPRIETARY
class Stats{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async getLanguages(){
        try{
            const all = await this.getAll()
            return all.filter(db=>db.iden.includes("main.")).map(db=>db.language).filter(lang=>lang!="linux")
        }  
        catch(e){
            console.log(e)
            throw e
        }
    } 
    
    async getAll(){
        try{
            const req = await fetch(`${this.baseUrl}/api/v1/stats/advisories-dbs`,{
                headers: this.headers.generate()
            })
            if(!req.ok) throw await req.json()
            return await req.json()
        }  
        catch(e){
            console.log(e)
            throw e
        }
    }

    async getDatabases(stats=null){
        if(!stats) stats = await this.getAll()
        const dbs = stats.filter(db=>db.language==null)
        return dbs
    }

    async getPublicVulnerabilities(){
        try{
            const req = await fetch(`${this.baseUrl}/stats/public-vulns.json`)
            if(!req.ok) throw await req.json()
            return await req.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}


// License: PROPRIETARY
class Languages {
    constructor(baseUrl = ""){
        this.baseUrl = baseUrl
    }
    async get(tool){
        try{
            tool = tool ? "?tool="+tool : ""
            const request = await fetch(`${this.baseUrl}/api/v1/admin/core/languages`+tool)
            return await request.json()
        }
        catch(e){
            console.log("Could not get Languages")
            console.log(e)
            return []
        }
    }

    async all(){
        return await this.get()
    }
    async boss(){
        return await this.get("boss")
    }
    async bossc(){
        return await this.get("bossc")
    }
    async isaac(){
        return await this.get("isaac")
    }
    async cpedia(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/componentpedia/supported_languages`)
            if(!request.ok) throw new Error("Componentpedia languages not available")
            const cpediaLanguages = await request.json()
            return cpediaLanguages.languages
        }
        catch(e){
            return []
        }
    }
}


// License: PROPRIETARY
class Licenses {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async search(query){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/licenses?query=${utils.cleanEncodeURIComponent(query)}`, { headers: this.headers.generate() })
            if (request.status !== 200) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
       
    }

    getBaseUrl(language, name, version) {
        version = version && version.length? version : "0"
        return `${this.baseUrl}/api/v1/licenses/library/${utils.encodeString(language)}/${utils.encodeString(name)}/${utils.encodeString(version)}`
    }
    async updateCopyright(data, query) {
        const {language, name} = data.content.library
        const {version} = data.content
        const baseUrl = this.getBaseUrl(language, name, version)
        const url = baseUrl + `/copyright?text=${encodeURI(query)}`
        const headers = { ...this.headers.generate("application/json") }
        try {
            const response = await fetch(url, { method: "POST", headers })
            if (response.status !== 200) throw new Error(response.message)
            return
        } catch (e) {
            throw (e)
        }
    }
    
    async getCopyright(data) {
        const {language, name} = data.content.library
        const {version} = data.content
        const baseUrl = this.getBaseUrl(language, name, version)
        const url = baseUrl + `/copyright`
        const headers = { ...this.headers.generate("application/json") }
        try {
            const response = await fetch(url, { headers })
            if (response.status !== 200) throw new Error(response.message)
            return await response.json()
        } catch (e) {
            return {text: ""}
        }
    }

    async getLicenses(data) {
        const {language, name} = data.library
        const {version} = data
        const baseUrl = this.getBaseUrl(language, name, version)
        const headers = { ...this.headers.generate("application/json") }
        try {
            const response = await fetch(baseUrl, { headers })
            if (response.status !== 200) throw new Error(response.message)
            return (await response.json())
        } catch (e) {
            throw (e)
        }
    }

    async addLicense(data, id) {
        const {language, name} = data.library
        const {version} = data
        const baseUrl = this.getBaseUrl(language, name, version )
        const url = baseUrl + `/${utils.encodeString(id)}`
        const headers = { ...this.headers.generate("application/json") }
        try {
            const response = await fetch(url, { method: "POST", headers })
            if (response.status !== 200) throw new Error(response.message)
            return
        } catch (e) {
            throw (e)
        }
    }

    async deleteLicense(data, id) {
        const {language, name} = data.library
        const {version} = data
        const baseUrl = this.getBaseUrl(language, name, version )
        const url = baseUrl + `/${utils.encodeString(id)}`
        const headers = { ...this.headers.generate("application/json") }
        try {
            const response = await fetch(url, { method: "DELETE", headers })
            if (response.status !== 200) throw new Error(response.message)
            return
        } catch (e) {
            throw (e)
        }
    }

    async getAccountLicenses(accountId) {
        try{
            const url = `${this.baseUrl}/api/v1/accounts/${accountId}/overrides/licenses`
            const response = await fetch(url, { headers: this.headers.generate() })
            if (response.status !== 200) throw await response.json()
            return await response.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async getAccountCopyrights(accountId) {
        try{
            const url = `${this.baseUrl}/api/v1/accounts/${accountId}/overrides/copyrights`
            const response = await fetch(url, { headers: this.headers.generate() })
            if (response.status !== 200) throw await response.json()
            return await response.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    
}


class MercuryEmail{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)

    }
    
    async sendTestNotification(teamUuid) { 
        await fetch(`${this.baseUrl}/api/v1/notifications/notify_test?type=email&team=`+teamUuid, {
            headers: this.headers.generate(),
            method: "POST",
        })
    }

    async sendEmail(subject, message, recepients){
        await fetch(`${this.baseUrl}/api/v1/notifications/send_email`, {
            headers: this.headers.generate("application/json"),
            method: "POST",
            body: JSON.stringify({
                subject, content: message, recepients
            })
        })  
    }
}


class MercurySlackLockV2{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async borrow(teamUuid, state){
        try{
            const query = ["teamUuid="+teamUuid, "state="+state].join("&")
            const request = await fetch(`${this.baseUrl}/api/v2/notifications/slack/locks/borrow?`+query,{
                method: "POST",
                headers: this.headers.generate()
            })
            return await request.json()
        }
        catch(e){
            throw e 
        }
    }

    async status(team){
        try{
            const request = await fetch(`${this.baseUrl}/api/v2/notifications/slack/locks/status?team=`+team)
            return await request.json()
        }
        catch(e){
            throw e
        }
    }

    async getRentalTimeInfo(){
        const request = await fetch(`${this.baseUrl}/api/v2/notifications/slack/locks/rentalTime`)
        return await request.json()
    }



}


class MercurySlack{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.locksV2 = new MercurySlackLockV2(headers, baseUrl)
    }
    async finalize(ticket){
        try{
            const request = await fetch(`${this.baseUrl}/api/v2/notifications/slack/info?ticket=`+ticket,{
                headers: this.headers.generate()
            })
            const info = await request.json()
            return info
        }
        catch(e){
            throw e
        }
    }

    async sendTestNotification(teamUuid) { 
        await fetch(`${this.baseUrl}/api/v1/notifications/notify_test?type=slack&team=`+teamUuid, {
            method: "POST",
            headers: this.headers.generate()
        })
    }
    
}

class Mercury{

    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.email = new MercuryEmail(this.headers, this.baseUrl)
        this.slack = new MercurySlack(this.headers, this.baseUrl)
    }

    async getConfiguration(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/notifications/config`)
            return request
        }
        catch(e){
            throw e
        }
    }

    async getConfigurationV2(){
        try{
            const url = await this.trickFollowRedirectAndReturnUrl()
            const req = await fetch(url, {headers: this.headers.generate()})
            return await req.json()
        }
        catch(e){
            throw e
        }


    }
    async trickFollowRedirectAndReturnUrl(){
        try{
            const request = await this.getConfiguration()
            return request.url
        }
        catch(e){
            return e.url
        }
    }

    setBaseurl(url){
        this.email.baseUrl = url
        this.slack.baseUrl = url
        this.slack.locksV2.baseUrl = url
    }

    async sendTestNotification(teamUuid, type) {
        await this[type].sendTestNotification(teamUuid)
    }
    
}


class Scopes{
    constructor(baseUrl=""){
        this.baseUrl = baseUrl
    }
    async get(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/admin/core/scopes`)
            if(!request.ok) throw await request.json()
            this.scopes = await request.json()
        }
        catch(e){
            console.log(e)
            this.scopes = []
            throw e
        }
    }
}


//License: PROPRIETARY
class Eras{
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    async request(selection, nocache=false){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/eras?nocache=${nocache}`, {
                headers: this.headers.generate("application/json"),
                method: "POST",
                body: JSON.stringify(selection)
            })
            if(request.status>201) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async status(id){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/eras/`+id, {
                headers: this.headers.generate()
            })
            if(request.status!=200 && request.status!=404) throw await request.json()
            if(request.status>200) return await request.text()
            return "100"
        }
        catch(e){
            console.log(e)
            if(e.status==404) return await e.text()
            return "0"
        }
    }

    async get(id, type, format, downloadKey, redirect=false, self=true){
        try{
            if(redirect) return window.open(`${this.baseUrl}/api/v1/eras/${id}/report.${format.toLowerCase()}?downloadKey=${utils.cleanEncodeURIComponent(downloadKey)}`, self?"_self":"_blank")
            
            const request = await fetch(`${this.baseUrl}/api/v1/eras/${id}/report.${format.toLowerCase()}`, {
                headers: this.headers.generate()
            })
            if(request.status>200) return await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    async config(){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/eras/config`, {
                headers: this.headers.generate()
            })
            if(request.status>200) return await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
}



class Chai {
    constructor(headers) {
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.baseUrl = this.chaiBaseUrl()
    }
    chaiBaseUrl() {
        const env = this.getEnv()
        const mappedEnv = {local: "qa", qa: "qa", alpha: "www", www: "www"}
        return `https://chai.${mappedEnv[env] || "www"}.meterian.io`
    }
    getEnv() {
        return window.location.host.split(".")[0]
    }
    async startSummaryConversation(advice) {
        if(!advice) throw { message: "Cannot start conversation without specifying advice" }
        let url = `${this.baseUrl}/api/v1/barista/conversations/with_summary`
        const options = {method: "POST", headers: this.headers.generate("application/json"), body: JSON.stringify(advice) }
        try {
            return await window.fetch(url, options)
        } catch(e) {
            console.log(e)
            throw await e.json()
        }
    }
    async startConversation(advice) {
        if(!advice) throw { message: "Cannot start conversation without specifying advice" }
        let url = `${this.baseUrl}/api/v1/barista/conversations/around_vulnerability`
        const options = {method: "POST", headers: this.headers.generate("application/json"), body: JSON.stringify(advice) }
        try {
            const request = await window.fetch(url, options)
            return await request.json()
        } catch(e) {
            console.log(e)
            throw await e.json()
        }
    }
    async ask(conversationId, question) {
        if(!conversationId) throw { message: "Conversation id is not specified"}
        let url = `${this.baseUrl}/api/v1/barista/conversations/${conversationId}/ask`
        const options = {method: "PUT", headers: this.headers.generate("application/json"), body: JSON.stringify({question}) }
        try {
            return await window.fetch(url, options)
        } catch(e) {
            console.log(e)
            throw await e.json()
        }
    }
    async ping() {
        try {
            const url = this.baseUrl + "/admin/server/barista/ping"
            return window.fetch(url)
        } catch(e) {
            throw await e.json()
        }
    }
}



class Advisory {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }
    
    async getAdvice(db, id) {
        return await this.getById(db, id)
    }

    async get(db, id = null, queryParams){
        if(id && id.length) return await this.getById(db, id)
        const query = []
        this.cleanupQuery(queryParams)
        const queryParamsToKeep = ["limit", "offset"]
        for(const key in queryParams){
            if(!queryParamsToKeep.includes(key) && (!queryParams[key] || !queryParams[key].length )) continue 
            query.push(`${key}=${encodeURIComponent(queryParams[key])}`)
        }
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/vulns/${db}?${query.join("&")}`,{
                headers: this.headers.generate("application/json")
            })
            if(request.status!=200) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }
    async getById(db, id){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/vulns/${db}/${id}`,{
                headers: this.headers.generate("application/json")
            })
            if(request.status!=200) throw await request.json()
            return await request.json()
        }
        catch(e){
            console.log(e)
            throw e
        }
    }

    cleanupQuery(queryParams){
        delete queryParams.language
        delete queryParams.component
        delete queryParams.version

        delete queryParams.severity
        delete queryParams.cvss
    }
}



class Metrics {
    constructor(headers, baseUrl = ""){
        this.baseUrl = `${baseUrl}/api/v1/metrics/security/me`
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async get(queryParams) {
        try {
            const response = await fetch(this.baseUrl+"?"+ queryParams, {headers:  this.headers.generate()})
            return response.json()
        } catch(e) {
            await await e.json()
        }
    }
}



class ScratchCodesFactor {
	constructor(headers) {
		const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
	}

	async get(){
		try{
			const scratchCodes = await fetch(`/api/v1/mfa/scratch-codes`,{
				headers: this.headers.generate()
			})
            return await scratchCodes.json()
		}
		catch(e){
			console.log(e);
			throw await e.json()
		}
	}
	async set() {
        try{
			const generatedCodes = await fetch(`/api/v1/mfa/scratch-codes`,{
				headers: this.headers.generate(null, true),
                method: "POST"
			})
            return await generatedCodes.json()
		}
		catch(e){
			console.log(e);
			throw await e.json()
		}
    }
	async delete() {
        try{
		 	await fetch(`/api/v1/mfa/scratch-codes`,{
				headers: this.headers.generate(null, true),
                method: "DELETE"
			})
		}
		catch(e){
			console.log(e);
			throw await e.json()
		}
    }
}

class SMSFactor {

	constructor(headers) {
		const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
	}

	async get(){
		try{
			const scratchCodes = await fetch(`/api/v1/mfa/sms`,{
				headers: this.headers.generate(null)
			})
            return await scratchCodes.json()
		}
		catch(e){
			console.log(e);
			throw await e.json()
		}
	}
	async set(phone) {
        try{
			return await fetch(`/api/v1/mfa/sms`,{
				headers: this.headers.generate("application/json", true),
                method: "POST",
				body: JSON.stringify({phone:phone})
			})
		}
		catch(e){
			console.log(e);
			throw await e.json()
		}
    }
	async delete() {
        try{
		 	await fetch(`/api/v1/mfa/sms`,{
				headers: this.headers.generate(null, true),
                method: "DELETE"
			})
		}
		catch(e){
			console.log(e);
			throw await e.json()
		}
    }
	async setup(phone) {
        try{
			return await fetch(`/api/v1/mfa/sms/setup`,{
				headers: this.headers.generate("application/json", true),
                method: "POST",
				body: JSON.stringify({target: phone})
			})
		}
		catch(e){
			console.log(e);
			throw await e.json()
		}
    }
}


class AuthenticatorFactor {

	constructor(headers) {
		const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
	}

	async get(){
		try{
			const scratchCodes = await fetch(`/api/v1/mfa/app`,{
				headers: this.headers.generate()
			})
            return await scratchCodes.json()
		}
		catch(e){
			console.log(e);
			throw await e.json()
		}
	}
	async set() {
        try{
			const generatedCodes = await fetch(`/api/v1/mfa/app`,{
				headers: this.headers.generate(null, true),
                method: "POST"
			})
            return await generatedCodes.json()
		}
		catch(e){
			console.log(e);
			throw await e.json()
		}
    }
	async delete() {
        try{
		 	await fetch(`/api/v1/mfa/app`,{
				headers: this.headers.generate(null, true),
                method: "DELETE"
			})
		}
		catch(e){
			console.log(e);
			throw await e.json()
		}
    }

	async finalize(totp) {
		try {
			const res = await fetch(`/api/v1/mfa/challenge/app/verify?isSetup=true`, {
				headers: this.headers.generate("application/json"),
				method: "POST",
				body: JSON.stringify({totp})
			})
			return true
		} catch(e) {
			console.log(e)
			throw await e.json()
		}
	}

}

class Mfa {
    constructor(headers) {
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)

		this.scratchCodes = new ScratchCodesFactor(this.headers)
		this.sms = new SMSFactor(this.headers)
		this.authenticator = new AuthenticatorFactor(this.headers)
    }

	async activeFactors() {
		try{
			const res = await fetch(`/api/v1/mfa/factors`,{
				headers: this.headers.generate()
			})
            return await res.json()
		}
		catch(e){
			return ["email"]
		}
	}

	async verify(type, totp, opt) {
		try {
			const res = await fetch(`/api/v1/mfa/challenge/${type}/verify`, {
				headers: this.headers.generate("application/json"),
				method: "POST",
				body: JSON.stringify({totp})
			})
			return await res.json()
		} catch(e) {
			console.log(e)
			throw await e.json()
		}
	}

	async startChallenge(type, target) {
		try {
			await fetch(`/api/v1/mfa/challenge/${type}/start`, {
				headers: this.headers.generate("application/json"),
				method: "POST",
				body: JSON.stringify({target})
			})
			return true
		} catch(e) {
			throw await e.json()
		}
	}

	
}


class Cli {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async update(){
        const request = await fetch(`${this.baseUrl}/api/v1/cli/update`,{
            method: "POST", 
            headers: this.headers.generate()
        })
        const response = await request.json()
        return response
    }

    async updateStatus(){
        const request = await fetch(`${this.baseUrl}/api/v1/cli/update`,{
            headers: this.headers.generate()
        })
        const response = await request.json()
        return response
    }
}


// License: PROPRIETARY

class SashaExclusions {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async get(projectUuid, branch){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/sasha/projects/${projectUuid}/exclusions?branch=${branch}`, {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return request.json()
        }
        catch (e) {
            if(e.json) {
                const error = await e.json()
                console.log(error)
                throw error
            }
            console.log(e)
            throw e
        }
    }

    async acceptFindings(projectUuid, branch, exclusions, findings){
        
        for (const finding of findings) {
            exclusions = exclusions.filter(exclusion => exclusion.finding != finding)
            exclusions.push({
                finding,
                reason: "accepted"
            })
        }

        await this.uploadExclusions(projectUuid, branch, exclusions)
    }

    async rejectFindings(projectUuid, branch, exclusions, findings){


        for (const finding of findings) {
            exclusions = exclusions.filter(exclusion => exclusion.finding != finding)
            exclusions.push({
                finding,
                reason: "rejected"
            })
        }

        await this.uploadExclusions(projectUuid, branch, exclusions)
    }

    async uploadExclusions(projectUuid, branch, exclusions){
        try{
            const request = await fetch(`${this.baseUrl}/api/v1/sasha/projects/${projectUuid}/exclusions?branch=${branch}`, {
                method: "PUT",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify({exclusions})
            })
            if (request.status != 200) throw await request.json()
            return 
        }
        catch (e) {
            if(e.json) {
                const error = await e.json()
                console.log(error)
                throw error
            }
            console.log(e)
            throw e
        }
    }
}


// License: PROPRIETARY

class Sasha {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers ||  new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.exclusions = new SashaExclusions(this.headers, this.baseUrl)
    }
    async get(uuid, branch){
        try{
            const query = []
            if(branch) query.push(`branch=${branch}`)
            if(query.length > 0) query.unshift("?")
            const request = await fetch(`${this.baseUrl}/api/v1/sasha/projects/${uuid}/report${query.join("&")}`, {
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return request.json()
        }
        catch (e) {
            if(e.json) {
                const error = await e.json()
                console.log(error)
                throw error
            }
            console.log(e)
            throw e
        }
    }

    async recompute(uuid, branch){
        try{
            const query = []
            if(branch) query.push(`branch=${branch}`)
            if(query.length > 0) query.unshift("?")
            const request = await fetch(`${this.baseUrl}/api/v1/sasha/projects/${uuid}/recompute${query.join("&")}`, {
                method: "POST",
                headers: this.headers.generate()
            })
            if (request.status != 200) throw await request.json()
            return request.json()
        }
        catch (e) {
            if(e.json) {
                const error = await e.json()
                console.log(error)
                throw error
            }
            console.log(e)
            throw e
        }
    }
}


class Validators {
    constructor(headers, baseUrl = ""){
        this.baseUrl = baseUrl
        const isWeb = !!window
        this.headers = headers || new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
    }

    async scmurl(url){
        
        await fetch(`${this.baseUrl}/api/v1/validators/scmurl`,{
            method: "POST", 
            headers: this.headers.generate(),
            body: url
        })
    }

}


// License: PROPRIETARY

class Sso {
    constructor(headers, baseUrl = "") {
        const isWeb = typeof window !== 'undefined'
        this.headers = headers || new Headers(isWeb ? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.baseUrl = baseUrl
    }

    async schema(ssoType) {
        try {
            const res = await fetch(`${this.baseUrl}/api/v1/${ssoType}/configuration-schema`, {
                headers: this.headers.generate()
            })
            if (res.status !== 200) throw await res.json()
            return await res.json()
        } catch (e) {
            console.error(e)
            throw e
        }
    }

    async save(ssoType, name, data) {
        try {
            const res = await fetch(`${this.baseUrl}/api/v1/${ssoType}/${name}/config`, {
                method: "POST",
                headers: this.headers.generate("application/json"),
                body: JSON.stringify(data)
            })
            if (res.status !== 200) throw await res.json()
            return await res.json()
        } catch (e) {
            console.error(e)
            throw e
        }
    }

    async get(ssoType, name) {
        try {
            const res = await fetch(`${this.baseUrl}/api/v1/${ssoType}/${name}/config`, {
                headers: this.headers.generate()
            })
            if (res.status !== 200) throw await res.json()
            return await res.json()
        } catch (e) {
            console.error(e)
            throw e
        }
    }

    async delete(ssoType, name) {
        try {
            const res = await fetch(`${this.baseUrl}/api/v1/${ssoType}/${name}/config`, {
                method: "DELETE",
                headers: this.headers.generate()
            })
            if (res.status !== 200 && res.status !== 404) throw await res.json()
        } catch (e) {
            console.error(e)
            throw e
        }
    }
}


// License: PROPRIETARY


class MeterianSDK{
    constructor(baseUrl = ""){
        const isWeb = !!window
        
        this.headers = new Headers( isWeb? AuthTypes.BEARER : AuthTypes.TOKEN)
        this.accounts = new Accounts(this.headers, baseUrl);
        this.users = new Users(this.headers, baseUrl)
        this.teams = new Teams(this.headers, baseUrl);
        this.projects = new Projects(this.headers, baseUrl);
        this.dependencies = new Dependencies(this.headers, baseUrl);
        this.reports = new Reports(this.headers, baseUrl);
        this.eras = new Eras(this.headers, baseUrl);
        this.tags = new Tags(this.headers, baseUrl);
        this.site_server = new SiteServer(this.headers, baseUrl);
        this.admin = new ServicesAdmin(baseUrl)
        this.isaac = new Isaac(this.headers, baseUrl);
        this.allerta = new Allerta(baseUrl);
        this.stats = new Stats(this.headers, baseUrl)
        this.languages = new Languages(baseUrl);
        this.licenses = new Licenses(this.headers, baseUrl)
        this.mercury = new Mercury(this.headers, baseUrl)
        this.scopes = new Scopes(baseUrl)
        this.chai = new Chai(this.headers, baseUrl)
        this.advisory = new Advisory(this.headers, baseUrl)
        this.utils = utils
        this.metrics = new Metrics(this.headers, baseUrl)
        this.mfa = new Mfa(this.headers, baseUrl)
        this.cli = new Cli(this.headers, baseUrl)
        this.sasha = new Sasha(this.headers, baseUrl)
        this.validators = new Validators(this.headers, baseUrl)
        this.sso = new Sso(this.headers, baseUrl)
    }
    
    async init(){
        await this.accounts.features.all();
        await this.accounts.plans.all();
        await this.accounts.properties.all();
        await this.teams.properties.all();
    }

    async load(profile){
        this.headers.updateAuth(null, this.headers.type)
        this.languages.list = await this.languages.boss()
        this.languages.list.sort()
        await this.accounts.features.init(profile);
        await this.scopes.get()
        this.accounts.integrations.init()
    }
    
}


export default MeterianSDK
